<style>
    .wrapperx {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .m-form .m-form__group:first-child {
        padding-top: 15px;
    }

</style>

<template>
    <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
        <div class="row m-portlet__body">
            <div class="col-md-6">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('name')}">
                    <label>
                        {{$t('Name')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="model.name">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('name')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('url')}">
                    <label>
                        {{$t('URL')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="model.url">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('url')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/categories/index`"></Buttons>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
export default {
  name: 'CategoryForm',
  components: {Buttons},
  props: {
    model: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    },
    url: {
      require: true
    }
  },
  watch: {
    model: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
        if (val && val.url !== undefined && val.url !== null) {
          this.model.url = this.model.url.toLowerCase()
          if (val.url.startsWith('/') === false) {
            this.model.url = '/' + this.model.url
          }
          this.model.url = this.model.url.replace(' ', '-')
        }
      },
      deep: true
    }
  },
  methods: {
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    save () {
      this.$store.commit('loading/changeUnsaved', false)
      this.$emit('save')
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/category/CategoryForm.vue